import React from 'react';
import { useOutletContext } from 'react-router-dom';
import type { AssetRef } from '../../types/place';

import AudioPlayer from '../players/AudioPlayer';
import textsMapper from '../../staticTexts/texts';
import { useAppSelector } from '../../redux/hooks';
import { selectCurrentLanguage, selectDirection } from '../../redux/selectors';
import { Typography } from '@mui/material';

interface AudioDescriptionWidgetProps {
    audio: AssetRef | null;
}

const AudioDescriptionWidget: React.FC<AudioDescriptionWidgetProps> = ({audio}) => {
    
    const currentLanguage = useAppSelector(selectCurrentLanguage)
    const direction = useAppSelector(selectDirection)

    if (audio === null) {
        return (

                <Typography variant='h2' sx={{mt: '20%', direction: direction}}>
                {(textsMapper.pages.stationPage.error as Record<string, string>)[(currentLanguage ?? 'en').split('-')[0]]
}
                </Typography>

        )
    }

    return (
        <div>
            <AudioPlayer audio={audio.id} />
        </div>
    );
};

export default AudioDescriptionWidget;
